/*
  Collection pages v2 (theme setting metax_collection_v2).
  - When another colour is picked, the card shows only that colour's photo
    (the other slides belong to the original colour), and swiping returns
    when the original colour is picked again, with the card's own first photo
    (possibly a lifestyle shot) restored.
  Uses one delegated listener, so cards re-rendered by filters/pagination work too.
*/
(() => {
  if (window.__metaxCollectionV2) return;
  window.__metaxCollectionV2 = true;

  const ROOT = '.metax-collection-v2';
  const CARD = '.product-grid__item';
  const originals = new WeakMap();

  // Registered on window (capture), so it runs BEFORE the colour handler in
  // blocks/_product-card.liquid, which listens on document (capture) and calls
  // stopImmediatePropagation(): a document listener here would never run.
  window.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(`${ROOT} .metax-related-colors__item`);
      if (!button) return;
      const card = button.closest(CARD);
      if (!card) return;

      // All photos of the card (not the colour thumbnails). Products with several
      // generic photos (e.g. Faos) show the 2nd one on mouse hover, so every slide
      // must show the picked colour, not only the first.
      const galleryImages = Array.from(card.querySelectorAll('.card-gallery img')).filter(
        (img) => !img.closest('.metax-related-colors')
      );

      if (!card.dataset.mxOriginalColor) {
        const current = card.querySelector('.metax-related-colors__item.is-active');
        card.dataset.mxOriginalColor = current ? current.dataset.colorIndex || '' : '';
        originals.set(
          card,
          galleryImages.map((img) => ({
            img,
            src: img.getAttribute('src'),
            srcset: img.getAttribute('srcset'),
            sizes: img.getAttribute('sizes'),
          }))
        );
      }

      const track = card.querySelector('.card-gallery slideshow-slides');
      if (track) track.scrollLeft = 0;
      const slideshow = card.querySelector('.card-gallery slideshow-component');

      const isOriginal = (button.dataset.colorIndex || '') === card.dataset.mxOriginalColor;
      card.classList.toggle('mx-color-swapped', !isOriginal);
      const pickedImage = (button.dataset.colorImage || '').trim();

      // Runs after the existing handler (which only swaps the first photo).
      setTimeout(() => {
        if (isOriginal && originals.has(card)) {
          // Back on the original colour: restore every photo (the first may be a lifestyle shot).
          originals.get(card).forEach((saved) => {
            if (saved.srcset) saved.img.setAttribute('srcset', saved.srcset);
            if (saved.sizes) saved.img.setAttribute('sizes', saved.sizes);
            if (saved.src) saved.img.setAttribute('src', saved.src);
          });
        } else if (pickedImage) {
          galleryImages.forEach((img) => {
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.setAttribute('src', pickedImage);
          });
        }
        try {
          if (slideshow && typeof slideshow.select === 'function') {
            slideshow.select(0, undefined, { animate: false });
          }
        } catch (e) {
          /* slideshow not ready: the scroll reset above is enough */
        }
      }, 0);

    },
    true
  );

})();
